import { render, staticRenderFns } from "./RednaxDatatableComponent.vue?vue&type=template&id=c5696770&scoped=true&"
import script from "./RednaxDatatableComponent.vue?vue&type=script&lang=js&"
export * from "./RednaxDatatableComponent.vue?vue&type=script&lang=js&"
import style0 from "./RednaxDatatableComponent.vue?vue&type=style&index=0&id=c5696770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5696770",
  null
  
)

export default component.exports